import React from 'react';

const HeroImage = () => {
  return (
    <div className="hero-image">
      <h1>Bienvenidos a M & Bricks</h1>
    </div>
  );
};

export default HeroImage;
